import { z } from 'zod';

export const featureFlagsSchema = z
  .object({
    annotations: z.boolean().default(false),
    cropping: z.boolean().default(false),
    segmentation: z.boolean().default(false),
    implantPlanning: z.boolean().default(false),
    remoteServer: z.boolean().default(false),
  })
  .default({
    annotations: false,
    cropping: false,
    segmentation: false,
    implantPlanning: false,
    remoteServer: false,
  });

export const profileSchema = z.object({
  features: featureFlagsSchema,
});

export type FeatureFlags = z.infer<typeof featureFlagsSchema>;
export type ViewerProfile = z.infer<typeof profileSchema>;

export const defaultFeatureFlags: FeatureFlags = featureFlagsSchema.parse({});

export function parseProfile(raw: unknown): ViewerProfile {
  return profileSchema.parse(raw);
}

/** Maps camelCase feature keys to compile-time `__FEATURE_*__` constant names. */
export const FEATURE_DEFINE_KEYS = {
  annotations: '__FEATURE_ANNOTATIONS__',
  cropping: '__FEATURE_CROPPING__',
  segmentation: '__FEATURE_SEGMENTATION__',
  implantPlanning: '__FEATURE_IMPLANT_PLANNING__',
  remoteServer: '__FEATURE_REMOTE_SERVER__',
} as const satisfies Record<keyof FeatureFlags, string>;

export type FeatureId = keyof FeatureFlags;
